module.exports = __webpack_public_path__ + "static/media/unitCrossBlue.a434e084.svg";